import './App.css';
import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import Header from './componentes/Header';
import ScrollManager from './componentes/ScrollManager';
import Home from './componentes/Home';
import Sections from './componentes/Sections';
import Footer from './componentes/Footer';
import AboutStaff from './componentes/AboutStaff';
import AboutUs from './componentes/AboutUs';

// Área de sócios: só existe no site quando REACT_APP_AREA_SOCIOS=ativa.
// Sem esta variável (ex.: no Cloudflare, enquanto o Supabase não estiver
// configurado) as páginas nem entram no build e os endereços levam ao início.
// (A condição tem de estar escrita aqui por extenso para o webpack descartar o import.)
const AreaSocios = process.env.REACT_APP_AREA_SOCIOS === 'ativa'
  ? lazy(() => import('./paginas/AreaSocios'))
  : null;
const PAGINAS_SOCIOS = ['inscricao', 'privacidade', 'login', 'treinador', 'admin'];

function App() {
  return (
    <Router>
      <MotionConfig reducedMotion="user">
        <ScrollManager />
        <div className="App">
          <Header />
          <main>
            <Suspense fallback={<p className="pagina-a-carregar" role="status">A carregar…</p>}>
              <Routes>
                <Route path="/" element={
                    <>
                      <Home />
                      <Sections />
                    </>
                  }
                />
                <Route path="/About_staff" element={<AboutStaff />} />
                <Route path="/About_us" element={<AboutUs />} />
                {PAGINAS_SOCIOS.map(nome => (
                  <Route
                    key={nome}
                    path={`/${nome}`}
                    element={AreaSocios ? <AreaSocios nome={nome} /> : <Navigate to="/" replace />}
                  />
                ))}
              </Routes>
            </Suspense>
          </main>
          <Footer />
        </div>
      </MotionConfig>
    </Router>
  );
}

export default App;
